import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { AppContext } from '../../App';

import { getIdFromUrl } from '../../utils/getIdFromUrl';
import useGlynt from './useGlynt';

export default function useUserDataPools() {
  const {
    orgId,
    orgLabel,
    dataPoolId,
    isStaff,
    setOrg,
    setOrgId,
    setOrgLabel,
    // setDataPoolId,
    // setDataPoolLabel,
    setDataPoolTotal,
    setIsStaff,
  } = React.useContext(AppContext);
  const glynt = useGlynt();

  const { data: userInfoData, isLoading: loadingUserInfo, isError } = useQuery({
    queryKey: ['userInfo'],
    queryFn: async () => await (await glynt).org.userInfo(),
    enabled: !isStaff || !orgId,
    refetchOnWindowFocus: false,
  });

  React.useEffect(() => {
    if (!userInfoData) return;
    // console.log(userInfoData);
    if (userInfoData && userInfoData.is_staff) {
      setIsStaff(true);
    }
    if (userInfoData.organizations.length === 1 && !orgId) {
      setOrgId(getIdFromUrl(userInfoData.organizations[0]));
      // what is data pool total for?
      setDataPoolTotal(String(userInfoData.data_pools.length));
    }
  }, [userInfoData]);

  // has duplicate cache if fetch in multiple components
  // it's also good to limit the drop down to 100 datapools,
  // if user wants to select datapools beyond 100, they can go to datapools page
  const { data, isLoading: loadingOrgDataPools } = useQuery({
    queryKey: ['dataPools', orgId],

    queryFn: async () =>
      await (
        await glynt
      ).dataPool.list({
        organization: orgId,
        limit: 100,
        advanced: true,
        ordering: 'label',
      }),

    enabled: !!orgId && !!dataPoolId,
    refetchOnWindowFocus: false
  });

  // Get org ID label
  const { data: orgData, isLoading: loadingOrg } = useQuery({
    queryKey: ['org'],
    queryFn: async () => await (await glynt).org.retrieve(orgId),
    enabled: !!orgId && !!orgLabel,
    refetchOnWindowFocus: false,
  });

  React.useEffect(() => {
    if (!orgData) return;
    setOrgLabel(orgData.label);
    setOrg(orgData);
  }, [orgData]);

  if (isError) {
    return { errored: true };
  }

  if (loadingUserInfo || loadingOrg || loadingOrgDataPools) {
    return null;
  }

  const orgDataPools = data?.results || [];

  return { orgDataPools, errored: false };
}
